
import React, { useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, Button } from 'carbon-components-react';
import i18n from "../../i18n";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';


require("./_manage-schedule.scss");

const ManageSchedulePage = props => {

    const AddNewSchedule = i18n.t('manageschedule.AddSchedule');
    const Home = i18n.t('manageschedule.Home');
    const ManageSchedule = i18n.t('manageschedule.ManageSchedule');
    const history = useHistory();

    useEffect(() => {


    }, []);

    return (
        <div className="page-margin padding-top-30px" style={{backgroundColor:'#F0F0F0'}}>

            <div className="bx--col-lg-4 bx--col-md-4 is-inline">
                <Breadcrumb noTrailingSlash aria-label="Page navigation">
                    <BreadcrumbItem href='/homepage'>
                        {Home}
                    </BreadcrumbItem>
                    <BreadcrumbItem href="#" isCurrentPage={true}>
                        {ManageSchedule}
                    </BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div className="is-inline">
                <Button onClick={() => history.push('/addSchedule')} className="add-button">
                    {AddNewSchedule}
                </Button>
            </div>
            <div>
                <hr className="line-shadow" />

            </div>

        </div>
    );
};

export default ManageSchedulePage;

